module.exports = "<div class=\"sr-only\" translate>PAGE_LOADING</div>\n<div class=\"dots-loader\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/common/pageLoader/pageLoader.html
// module id = 205
// module chunks = 1